// extracted by mini-css-extract-plugin
export default {"modalInner":"confirm_modal_modalInner__9dFnz","modalText":"confirm_modal_modalText__R3AxA","rowIcon":"confirm_modal_rowIcon__4kIIF"};